<mat-sidenav
  #sidenav
  mode="side"
  position="end"
  [opened]="isOpened"
  [disableClose]="true"
  class="bg-card flex w-[300px] fixed right-0 top-0 z-9999"
>
  <div class="h-screen flex flex-col justify-center w-full">
    
    <div
      class="flex h-[64px] items-center border-b justify-between bg-white text-gray-500 py-4 px-2 overscroll-none overflow-hidden"
    >
      <div class="flex gap-3">
        <mat-icon svgIcon="heroicons_outline:funnel" 
            class="mr-2 w-4 h-4"></mat-icon>
        <h2 class="text-current text-lg font-bold">Filtrar</h2>
      </div>
      <button
        id="filter-close-button"
        mat-icon-button
        class="h-full overflow-hidden overscroll-none"
        (wheel)="preventScroll($event)"
        (click)="togglePanel()"
        matTooltip="Cerrar"
      >
        <mat-icon 
        class="text-current"
        [svgIcon]="'heroicons_outline:x-mark'"
        ></mat-icon>
      </button>
    </div>

    <div class="flex-1 !text-black bg-gray-50 overflow-y-auto flex flex-col gap-1 pt-4 px-3">
      <ng-container *ngIf="isOpened || hasBeenOpened">
        <ng-content></ng-content>
      </ng-container>
    </div>

    <div class="flex h-[60px] justify-between mt-4 px-4">
      <button 
      mat-button 
      class="align-left text-gray-700 border border-gray-300" 
      (click)="onClean()"
      >Limpiar
    </button>
      <button 
      mat-raised-button 
      class="ml-auto bg-blue-950 text-white" 
      (click)="onFilter()">Aplicar</button>
    </div>
  </div>
</mat-sidenav>
